import env from "react-dotenv";
import { ServiceCommon } from "./service.common";
import { isEmpty } from "../utilities/validators";
import { TFilter } from "../types/FilterType";
import { TPagination } from "../types/PaginationType";

class CndService extends ServiceCommon {
    
    API_CND = env.API_CND;

    constructor() {
        super('CndService');
    }

    /* COMMON_AREA */
    async commonAreaById(commonAreaId: number) {
        const url = `${this.API_CND}/common_area/${commonAreaId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // commonAreaById

    async commonAreaList(attributes: string[], pagination?: TPagination) {
        const url = `${this.API_CND}/common_area/list`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // commonAreaList

    async commonAreaSearch(filter?: TFilter) {
        const url = `${this.API_CND}/common_area/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // commonAreaSearch

    async createCommonArea(commonArea: any) {
        const url = `${this.API_CND}/common_area/create`;

        try {
            return await this.postReturnObject(url, commonArea);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createCommonArea

    async saveCommonArea(commonAreaId: number, commonArea: any) {
        const url = `${this.API_CND}/common_area/save/${commonAreaId}`;

        try {
            return await this.putReturnObject(url, commonArea);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveCommonArea

    async commonAreaDeleteById(commonAreaId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/common_area/delete/${commonAreaId}`;
        else
            url = `${this.API_CND}/common_area/delete/${commonAreaId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // commonAreaDeleteById

    /* ENCOUNTER */
    async encounterById(encounterId: number) {
        const url = `${this.API_CND}/encounter/${encounterId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // encounterById

    async encounterList(attributes: string[], pagination?: TPagination) {
        const url = `${this.API_CND}/encounter/list`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // encounterList

    async encounterSearch(filter?: TFilter) {
        const url = `${this.API_CND}/encounter/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // encounterSearch

    async createEncounter(encounter: any) {
        const url = `${this.API_CND}/encounter/create`;

        try {
            return await this.postReturnObject(url, encounter);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createEncounter

    async saveEncounter(encounterId: number, encounter: any) {
        const url = `${this.API_CND}/encounter/save/${encounterId}`;

        try {
            return await this.putReturnObject(url, encounter);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveEncounter

    async encounterDeleteById(encounterId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/encounter/delete/${encounterId}`;
        else
            url = `${this.API_CND}/encounter/delete/${encounterId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // encounterDeleteById

    /* ESTATE */
    async estateById(estateId: number) {
        const url = `${this.API_CND}/estate/${estateId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateById

    async estateList(attributes: string[], pagination?: TPagination) {
        const url = `${this.API_CND}/estate/list`;

        try {
            const resultObject = await this.postReturnObject(url, { attributes, pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateList

    async estateSearch(filter?: TFilter) {
        const url = `${this.API_CND}/estate/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateSearch

    async createEstate(estate: any) {
        const url = `${this.API_CND}/estate/create`;

        try {
            return await this.postReturnObject(url, estate);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createEstate

    async saveEstate(estateId: number, estate: any) {
        const url = `${this.API_CND}/estate/save/${estateId}`;

        try {
            return await this.putReturnObject(url, estate);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveEstate

    async estateDeleteById(estateId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/estate/delete/${estateId}`;
        else
            url = `${this.API_CND}/estate/delete/${estateId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateDeleteById

    /* ESTATE_RESIDENT */

    async estateResidentById(residentId: number) {
        const url = `${this.API_CND}/estate_resident/${residentId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateResidentById

    async estateResidentList(pagination?: TPagination) {
        const url = `${this.API_CND}/estate_resident/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateResidentList

    async estateResidentSearch(filter?: TFilter) {
        const url = `${this.API_CND}/estate_resident/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateResidentSearch

    async saveEstateResident(residentId: number, resident: any) {
        const url = `${this.API_CND}/estate_resident/save/${residentId}`;

        try {
            return await this.putReturnObject(url, resident);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveEstateResident

    async createEstateResident(resident: any) {
        const url = `${this.API_CND}/estate_resident/create`;

        try {
            return await this.postReturnObject(url, resident);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createEstateResident

    async estateResidentDeleteById(residentId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/estate_resident/delete/${residentId}`;
        else
            url = `${this.API_CND}/estate_resident/delete/${residentId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateResidentDeleteById

    /* ESTATE_VISITOR */

    async estateVisitorById(visitorId: number) {
        const url = `${this.API_CND}/estate_visitor/${visitorId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateVisitorById

    async estateVisitorList(pagination?: TPagination) {
        const url = `${this.API_CND}/estate_visitor/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateVisitorList

    async estateVisitorSearch(filter?: TFilter) {
        const url = `${this.API_CND}/estate_visitor/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateVisitorSearch

    async saveEstateVisitor(visitorId: number, visitor: any) {
        const url = `${this.API_CND}/estate_visitor/save/${visitorId}`;

        try {
            return await this.putReturnObject(url, visitor);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveEstateVisitor

    async createEstateVisitor(visitor: any) {
        const url = `${this.API_CND}/estate_visitor/create`;

        try {
            return await this.postReturnObject(url, visitor);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createEstateVisitor

    async estateVisitorDeleteById(visitorId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/estate_visitor/delete/${visitorId}`;
        else
            url = `${this.API_CND}/estate_visitor/delete/${visitorId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateVisitorDeleteById

    /* INFRACTION */

    async infractionById(infractionId: number) {
        const url = `${this.API_CND}/infraction/${infractionId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // infractionById

    async infractionList(pagination?: TPagination) {
        const url = `${this.API_CND}/infraction/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // infractionList

    async infractionSearch(filter?: TFilter) {
        const url = `${this.API_CND}/infraction/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // infractionSearch

    async saveInfraction(infractionId: number, infraction: any) {
        const url = `${this.API_CND}/infraction/save/${infractionId}`;

        try {
            return await this.putReturnObject(url, infraction);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveInfraction

    async createInfraction(infraction: any) {
        const url = `${this.API_CND}/infraction/create`;

        try {
            return await this.postReturnObject(url, infraction);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createInfraction

    async infractionDeleteById(infractionId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/infraction/delete/${infractionId}`;
        else
            url = `${this.API_CND}/infraction/delete/${infractionId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // infractionDeleteById

    /* LOST_AND_FOUND */

    async lostAndFoundById(lostAndFoundId: number) {
        const url = `${this.API_CND}/lost_and_found/${lostAndFoundId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // lostAndFoundById

    async lostAndFoundList(pagination?: TPagination) {
        const url = `${this.API_CND}/lost_and_found/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // lostAndFoundList

    async lostAndFoundSearch(filter?: TFilter) {
        const url = `${this.API_CND}/lost_and_found/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // lostAndFoundSearch

    async saveLostAndFound(lostAndFoundId: number, lostAndFound: any) {
        const url = `${this.API_CND}/lost_and_found/save/${lostAndFoundId}`;

        try {
            return await this.putReturnObject(url, lostAndFound);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveLostAndFound

    async createLostAndFound(lostAndFound: any) {
        const url = `${this.API_CND}/lost_and_found/create`;

        try {
            return await this.postReturnObject(url, lostAndFound);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createLostAndFound

    async lostAndFoundDeleteById(lostAndFoundId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/lost_and_found/delete/${lostAndFoundId}`;
        else
            url = `${this.API_CND}/lost_and_found/delete/${lostAndFoundId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // lostAndFoundDeleteById

    /* NOTICE */

    async noticeById(noticeId: number) {
        const url = `${this.API_CND}/notice/${noticeId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // noticeById

    async noticeList(pagination?: TPagination) {
        const url = `${this.API_CND}/notice/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // noticeList

    async noticeSearch(filter?: TFilter) {
        const url = `${this.API_CND}/notice/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // noticeFilter

    async saveNotice(noticeId: number, notice: any) {
        const url = `${this.API_CND}/notice/save/${noticeId}`;

        try {
            return await this.putReturnObject(url, notice);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveNotice

    async createNotice(notice: any) {
        const url = `${this.API_CND}/notice/create`;

        try {
            return await this.postReturnObject(url, notice);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createNotice

    async noticeDeleteById(noticeId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/notice/delete/${noticeId}`;
        else
            url = `${this.API_CND}/notice/delete/${noticeId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // noticeDeleteById

    /* NOTIFICATION */

    async notificationById(notificationId: number) {
        const url = `${this.API_CND}/notification/${notificationId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // notificationById

    async notificationList(pagination?: TPagination) {
        const url = `${this.API_CND}/notification/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // notificationList

    async notificationSearch(filter?: TFilter) {
        const url = `${this.API_CND}/notification/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // notificationSearch

    async saveNotification(notificationId: number, notification: any) {
        const url = `${this.API_CND}/notification/save/${notificationId}`;

        try {
            return await this.putReturnObject(url, notification);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveNotification

    async createNotification(notification: any) {
        const url = `${this.API_CND}/notification/create`;

        try {
            return await this.postReturnObject(url, notification);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createNotification

    async notificationDeleteById(notificationId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/notification/delete/${notificationId}`;
        else
            url = `${this.API_CND}/notification/delete/${notificationId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // notificationDeleteById

    /* OCCURRENCE */

    async occurrenceById(occurrenceId: number) {
        const url = `${this.API_CND}/occurrence/${occurrenceId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // occurrenceById

    async occurrenceList(pagination?: TPagination) {
        const url = `${this.API_CND}/occurrence/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // occurrenceList

    async occurrenceSearch(filter?: TFilter) {
        const url = `${this.API_CND}/occurrence/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // occurrenceSearch

    async saveOccurrence(occurrenceId: number, occurrence: any) {
        const url = `${this.API_CND}/occurrence/save/${occurrenceId}`;

        try {
            return await this.putReturnObject(url, occurrence);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveOccurrence

    async createOccurrence(occurrence: any) {
        const url = `${this.API_CND}/occurrence/create`;

        try {
            return await this.postReturnObject(url, occurrence);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createOccurrence

    async occurrenceDeleteById(occurrenceId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/occurrence/delete/${occurrenceId}`;
        else
            url = `${this.API_CND}/occurrence/delete/${occurrenceId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // occurrenceDeleteById

    /* PENDENCY */

    async pendencyById(pendencyId: number) {
        const url = `${this.API_CND}/pendency/${pendencyId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // pendencyById

    async pendencyList(pagination?: TPagination) {
        const url = `${this.API_CND}/pendency/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // pendencyList

    async pendencySearch(filter?: TFilter) {
        const url = `${this.API_CND}/pendency/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // pendencySearch

    async savePendency(pendencyId: number, pendency: any) {
        const url = `${this.API_CND}/pendency/save/${pendencyId}`;

        try {
            return await this.putReturnObject(url, pendency);
        } catch (error: any) {
            throw new Error(error);
        }
    } // savePendency

    async createPendency(pendency: any) {
        const url = `${this.API_CND}/pendency/create`;

        try {
            return await this.postReturnObject(url, pendency);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createPendency

    async pendencyDeleteById(pendencyId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/pendency/delete/${pendencyId}`;
        else
            url = `${this.API_CND}/pendency/delete/${pendencyId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // pendencyDeleteById

    /* RESERVATION */

    async reservationById(reservationId: number) {
        const url = `${this.API_CND}/reservation/${reservationId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // reservationById

    async reservationList(pagination?: TPagination) {
        const url = `${this.API_CND}/reservation/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // reservationList

    async reservationSearch(filter?: TFilter) {
        const url = `${this.API_CND}/reservation/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // reservationSearch

    async saveReservation(reservationId: number, reservation: any) {
        const url = `${this.API_CND}/reservation/save/${reservationId}`;

        try {
            return await this.putReturnObject(url, reservation);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveReservation

    async createReservation(reservation: any) {
        const url = `${this.API_CND}/reservation/create`;

        try {
            return await this.postReturnObject(url, reservation);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createReservation

    async reservationDeleteById(reservationId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/reservation/delete/${reservationId}`;
        else
            url = `${this.API_CND}/reservation/delete/${reservationId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // reservationDeleteById

    /* RESIDENT */

    async residentById(residentId: number) {
        const url = `${this.API_CND}/resident/${residentId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // residentById

    async residentByEstate(estateId:number, pagination?: TPagination) {
        const url = `${this.API_CND}/resident/list/estate/${estateId}`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // residentList

    async residentList(pagination?: TPagination) {
        const url = `${this.API_CND}/resident/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // residentList

    async residentSearch(filter?: TFilter) {
        const url = `${this.API_CND}/resident/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter);
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // residentSearch

    async saveResident(residentId: number, resident: any) {
        const url = `${this.API_CND}/resident/save/${residentId}`;

        try {
            return await this.putReturnObject(url, resident);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveResident

    async createResident(resident: any) {
        const url = `${this.API_CND}/resident/create`;

        try {
            return await this.postReturnObject(url, resident);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createResident

    async residentDeleteById(residentId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/resident/delete/${residentId}`;
        else
            url = `${this.API_CND}/resident/delete/${residentId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // residentDeleteById

    /* SERVANT */

    async servantById(servantId: number) {
        const url = `${this.API_CND}/servant/${servantId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // servantById

    async servantByEstate(estateId: number, pagination?: TPagination) {
        const url = `${this.API_CND}/servant/list/estate/${estateId}`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // servantList

    async servantList(pagination?: TPagination) {
        const url = `${this.API_CND}/servant/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // servantList

    async servantSearch(filter?: TFilter) {
        const url = `${this.API_CND}/servant/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // servantSearch

    async saveServant(servantId: number, servant: any) {
        const url = `${this.API_CND}/servant/save/${servantId}`;

        try {
            return await this.putReturnObject(url, servant);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveServant

    async createServant(servant: any) {
        const url = `${this.API_CND}/servant/create`;

        try {
            return await this.postReturnObject(url, servant);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createServant

    async servantDeleteById(servantId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/servant/delete/${servantId}`;
        else
            url = `${this.API_CND}/servant/delete/${servantId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // servantDeleteById
    
    /* VEHICLE */

    async vehicleById(vehicleId: number) {
        const url = `${this.API_CND}/estate_vehicle/${vehicleId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // vehicleById

    async vehicleByEstate(estateId: number, pagination?: TPagination) {
        const url = `${this.API_CND}/estate_vehicle/list/estate/${estateId}`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // vehicleList

    async vehicleList(pagination?: TPagination) {
        const url = `${this.API_CND}/estate_vehicle/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // vehicleList

    async vehicleSearch(filter?: TFilter) {
        const url = `${this.API_CND}/estate_vehicle/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // vehicleSearch

    async saveVehicle(vehicleId: number, vehicle: any) {
        const url = `${this.API_CND}/estate_vehicle/save/${vehicleId}`;

        try {
            return await this.putReturnObject(url, vehicle);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveVehicle

    async createVehicle(vehicle: any) {
        const url = `${this.API_CND}/estate_vehicle/create`;

        try {
            return await this.postReturnObject(url, vehicle);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createVehicle

    async vehicleDeleteById(vehicleId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/estate_vehicle/delete/${vehicleId}`;
        else
            url = `${this.API_CND}/estate_vehicle/delete/${vehicleId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // vehicleDeleteById

    /* VESSEL */

    async estateAndVesselById(estateId: number, vesselId: number) {
        const url = `${this.API_CND}/estate_vessel/estate/${estateId}/vessel/${vesselId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // vesselById

    async estateByVessel(vesselId: number) {
        const url = `${this.API_CND}/estate_vessel/vessel/${vesselId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // estateByVessel

    async vesselByEstate(estateId: number) {
        const url = `${this.API_CND}/estate_vessel/list/estate/${estateId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // vesselByEstate

    async vesselList(pagination?: TPagination) {
        const url = `${this.API_CND}/estate_vessel/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // vesselList

    async vesselSearch(filter?: TFilter) {
        const url = `${this.API_CND}/estate_vessel/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // vesselSearch

    async saveVessel(vesselId: number, vessel: any) {
        const url = `${this.API_CND}/estate_vessel/save/${vesselId}`;

        try {
            return await this.putReturnObject(url, vessel);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveVessel

    async createVessel(vessel: any) {
        const url = `${this.API_CND}/estate_vessel/create`;

        try {
            return await this.postReturnObject(url, vessel);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createVessel

    async vesselDeleteById(vesselId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/estate_vessel/delete/${vesselId}`;
        else
            url = `${this.API_CND}/estate_vessel/delete/${vesselId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // vesselDeleteById

    /* VISITOR */

    async visitorById(visitorId: number) {
        const url = `${this.API_CND}/visitor/${visitorId}`;

        try {
            return await this.getReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // visitorById

    async visitorByEstate(estateId: number, pagination?: TPagination) {
        const url = `${this.API_CND}/visitor/list/estate/${estateId}`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // visitorList

    async visitorList(pagination?: TPagination) {
        const url = `${this.API_CND}/visitor/list`;

        try {
            const resultObject = await this.postReturnObject(url, { pagination });
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // visitorList

    async visitorSearch(filter?: TFilter) {
        const url = `${this.API_CND}/visitor/search`;

        try {
            const resultObject = await this.postReturnObject(url, filter );
            return resultObject;
        } catch (error: any) {
            throw new Error(error);
        }
    } // visitorSearch

    async saveVisitor(visitorId: number, visitor: any) {
        const url = `${this.API_CND}/visitor/save/${visitorId}`;

        try {
            return await this.putReturnObject(url, visitor);
        } catch (error: any) {
            throw new Error(error);
        }
    } // saveVisitor

    async createVisitor(visitor: any) {
        const url = `${this.API_CND}/visitor/create`;

        try {
            return await this.postReturnObject(url, visitor);
        } catch (error: any) {
            throw new Error(error);
        }
    } // createVisitor

    async visitorDeleteById(visitorId: number, comments?: any) {
        let url = '';
        if (isEmpty(comments))
            url = `${this.API_CND}/visitor/delete/${visitorId}`;
        else
            url = `${this.API_CND}/visitor/delete/${visitorId}/comments/${comments}`;

        try {
            return await this.deleteReturnObject(url);
        } catch (error: any) {
            throw new Error(error);
        }
    } // visitorDeleteById

}

// eslint-disable-next-line import/no-anonymous-default-export
export default new CndService();